import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from './NavBar';
import PrivacyModal from './PrivacyModal';
import './entremapHome.css';
import './entremapPublic.css';
const h = React.createElement;

export function PublicFooter() {
  return h('footer', { className: 'emap-footer' },
    h('div', { className: 'emap-container emap-footer-inner' },
      h('div', null, h(Link, { className: 'emap-footer-brand', to: '/' }, 'EntreMap', h('span', null, '.')),
        h('p', null, 'Explore. Assess. Grow.')),
      h('nav', { 'aria-label': 'Footer' },
        h(Link, {to:'/about'}, 'About us'), h(Link, {to:'/privacypolicy'}, 'Privacy policy'),
        h(Link, {to:'/contact'}, 'Contact'), h(Link, {to:'/faq'}, 'FAQ'),
        h('a', {href:'https://www.linkedin.com/company/entremap/'}, 'LinkedIn')),
      h('p', { className:'emap-copyright' }, '© ', new Date().getFullYear(), ' EntreMap')));
}
export function PageHeader({ eyebrow, title, accent, intro }) {
  return h('header', {className:'emap-page-heading'},
    h('div', {className:'emap-container'},
      h('p', {className:'emap-eyebrow'}, h('span', {className:'emap-eyebrow-line'}), eyebrow),
      h('h1', null, title, accent && h('span',null,accent)),
      h('p', {className:'emap-page-intro'}, intro)));
}
export function PublicCallToAction({ isLoggedIn }) {
  return h('section', {className:'emap-next emap-container', 'aria-labelledby':'emap-cta-title'},
    h('div', {className:'emap-next-copy'}, h('p',{className:'emap-eyebrow'},'A little reflection. A new perspective.'),
      h('h2',{id:'emap-cta-title'},'Explore your entrepreneurial mindset.'),
      h('p',null,'Discover your strengths and consider what comes next.')),
    h(PrivacyModal,{isLoggedIn,buttonLabel:'Start Assessment',buttonClassName:'emap-button emap-button--light',showArrow:true}));
}
export default function PublicLayout({ page, isLoggedIn, children }) {
  return h('div', {className:'emap-home emap-public-page'},
    h('a',{className:'emap-skip-link',href:'#main-content'},'Skip to content'),
    h(NavBar,{page,publicPage:true,isLoggedIn}),
    h('main',{id:'main-content',tabIndex:-1},children),
    h(PublicFooter));
}

